import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "search-form-layout" }
const _hoisted_2 = { class: "search-info-label" }
const _hoisted_3 = { class: "search-form-controls" }
const _hoisted_4 = { class: "search-form-input-row" }
const _hoisted_5 = {
  key: 0,
  class: "warning-text"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_k_input = _resolveComponent("k-input")!
  const _component_k_button = _resolveComponent("k-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.infoLabel) + ":", 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_k_input, {
          placeholder: _ctx.placeholder,
          modelValue: _ctx.inputValue,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValue) = $event)),
          modelModifiers: { trim: true },
          style: {"width":"100%","max-width":"250px"},
          onKeydown: _ctx.checkSubmit
        }, null, 8, ["placeholder", "modelValue", "onKeydown"]),
        _createVNode(_component_k_button, { onClick: _ctx.onSearchClick }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.localize('Search')), 1)
          ]),
          _: 1
        }, 8, ["onClick"]),
        _renderSlot(_ctx.$slots, "options")
      ]),
      (_ctx.searchError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.searchError), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}